import { getState } from './App';

export const defaultLogoUrl = '/images/stockpress-logo-alt-v2.png';
export const defaultShareLogoUrl = '/images/stockpress-logo-alt-v2.png';

export const getSettings = () => {
  const state = getState();
  if (state) {
    if (state.App.settings) {
      return state.App.settings;
    }
  }

  return [];
};

export const getUserSettings = () => {
  const state = getState();
  if (state) {
    if (state.Auth.profile && state.Auth.profile.settings) {
      return state.Auth.profile.settings;
    }
  }

  return [];
};

export const getSetting = (key) => {
  const settings = getSettings();
  if (key in settings) {
    return settings[key];
  }
  return null;
};

export const getUserSetting = (key) => {
  const settings = getUserSettings();
  if (key in settings) {
    return settings[key];
  }
  return null;
};
